var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.754 14C18.0494 13.9999 18.342 14.058 18.615 14.1709C18.8879 14.2839 19.136 14.4495 19.3449 14.6584C19.5539 14.8672 19.7196 15.1152 19.8327 15.3881C19.9458 15.6611 20.004 15.9536 20.004 16.249V17.167C20.0039 17.7405 19.8245 18.2996 19.491 18.766C17.945 20.929 15.42 22 12 22C8.578 22 6.055 20.928 4.513 18.763C4.18132 18.2973 4.00306 17.7398 4.003 17.168V16.248C4.00287 15.9526 4.06094 15.66 4.17391 15.3871C4.28687 15.1141 4.45251 14.866 4.66136 14.6571C4.87021 14.4482 5.11819 14.2824 5.39111 14.1693C5.66404 14.0562 5.95657 13.998 6.252 13.998H17.753L17.754 14ZM12 2.00403C13.3261 2.00403 14.5979 2.53081 15.5355 3.46849C16.4732 4.40618 17 5.67795 17 7.00403C17 8.33011 16.4732 9.60188 15.5355 10.5396C14.5979 11.4772 13.3261 12.004 12 12.004C10.6739 12.004 9.40215 11.4772 8.46446 10.5396C7.52678 9.60188 7 8.33011 7 7.00403C7 5.67795 7.52678 4.40618 8.46446 3.46849C9.40215 2.53081 10.6739 2.00403 12 2.00403V2.00403Z",
    fill: "#128087"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.7a5cea0bd0605365c0adfef1dab639b6.svg";
export { ForwardRef as ReactComponent };